import { default as authToken } from '~/src/shared/lib/auth_token.js';
/**
 * Handle username validation request.
 * @param {Object} options -
 * {
 *   endpoint: <String> - Username unique endpoint
 *   username: <String> - Username to validate
 *   authToken: <String> - Authentication token
 * }
 * @return {Object} - Request response.
 */
const usernameUniqueRequest = async (username) => {
  const formData = {
    username: encodeURIComponent(username),
    authenticity_token: authToken
  };
      
  // TODO - don't use the USER and EMAIL route globals. 
  return await doRequest('POST', formData, USER_ROUTE);
}

/**
 * Handle email validation request.
 * @param {Object} options -
 * {
 *   endpoint: <String> - email unique endpoint
 *   email: <String> - email to validate
 *   authToken: <String> - Authentication token
 * }
 * @return {Object} - Request response.
 */
const emailUniqueRequest = async (email) => {

  const formData = {
    email: email,
    authenticity_token: authToken
  };

  return await doRequest('POST', formData, EMAIL_ROUTE);
}

/**
 * Handle email validation request.
 * @param {Object} formData - Data to send.
 * @param {Object} options - 
 * {
 *   endpoint: <String> - endpoint to do request
 *   method: <String> - method type of request
 * }
 * @return {Object} - Request response.
 */
const doRequest = async (method, formData, endpoint) => {
  const data = {
    method: method,
    body: JSON.stringify(formData),
    headers: {
      "Content-Type": "application/json",
    }
  };
  const response = await fetch(endpoint, data);
  const body = await response.text();

  return JSON.parse(body);
}

export {
  usernameUniqueRequest,
  emailUniqueRequest,
};
